export type ThemeMode = 'light' | 'dark';

const STORAGE_KEY = 'aitras-theme';

/** The XTM tokens switch on `html[data-theme]`, so theming means setting that attribute. */
export function applyTheme(mode: ThemeMode): void {
  document.documentElement.dataset.theme = mode;
}

export function persistTheme(mode: ThemeMode): void {
  try {
    localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    // Ignore storage errors (private mode / disabled storage).
  }
}

function storedTheme(): ThemeMode | null {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    return value === 'dark' || value === 'light' ? value : null;
  } catch {
    return null;
  }
}

/** Persisted choice, else the OS preference, else light. */
export function resolveInitialTheme(): ThemeMode {
  const stored = storedTheme();
  if (stored) return stored;
  if (globalThis.matchMedia?.('(prefers-color-scheme: dark)').matches) {
    return 'dark';
  }
  return 'light';
}
